module.exports = __webpack_public_path__ + "assets/table_report_menu_icon-9b138d.svg";